export default "/moowstETH-WETH-BPT.80d50611a3741b1dcd2838e4a847a13b.png";